const searchingCondition = (keys) => (data, keyword) =>
    keys.some((key) => key in data && data[key].toLowerCase().includes(keyword.toLowerCase()))

export default searchingCondition;